import { getLeafValue } from "../../../helper";
import { VisitNodePassage } from "../../../types";
const createElement = (categoryName, value = 0, categorySummedValue = 0) => ({
    custom: {
        category: categoryName,
        categorySummedValue
    },
    name: categoryName,
    y: value
});
const updateRecordsCategorySum = (name, categorySummedValue, records) => {
    records.forEach((record) => {
        const rightPoint = record.data.find((point) => point.name === name);
        if (rightPoint && typeof rightPoint.custom?.categorySummedValue === "number") {
            rightPoint.custom.categorySummedValue = categorySummedValue;
        }
    });
};
const updateCategorySum = (category, actualSummedValue, valueToAdd, records) => {
    const newValue = actualSummedValue + valueToAdd;
    if (newValue !== 0) {
        updateRecordsCategorySum(category, newValue, records);
    }
};
const updateGroupCategories = (measureItem, record, chartConfig) => {
    const correspondingPoint = record.data.find((point) => point.name === measureItem.dimension && record.name === measureItem.measures?.[chartConfig.groupBy]);
    const itemValue = Number(getLeafValue(measureItem.measures?.[chartConfig.value])) ?? 0;
    if (correspondingPoint && correspondingPoint.y !== itemValue) {
        correspondingPoint.y = itemValue;
    }
    else if (!record.data.some((point) => point.name === measureItem.dimension) && record.name === measureItem.measures?.[chartConfig.groupBy]) {
        const value = Number(getLeafValue(measureItem.measures?.[chartConfig.value]));
        const category = measureItem.dimension?.toString();
        const newItem = createElement(category, value, 0);
        record.data.push(newItem);
    }
    else if (!record.data.some((value) => value.name === measureItem.dimension)) {
        record.data.push(createElement(measureItem.dimension, 0, 0));
    }
};
const updateCategorySummedValues = (item, records, chartConfig) => {
    const itemValue = Number(getLeafValue(item.measures?.[chartConfig.value])) ?? 0;
    const category = item.dimension;
    let actualSummedValue = 0;
    records.forEach((record) => record.data.forEach((point) => {
        if (point.name === category && actualSummedValue < point.custom?.categorySummedValue) {
            actualSummedValue = point.custom?.categorySummedValue;
        }
    }));
    updateCategorySum(category, actualSummedValue, itemValue, records);
};
const updateGroupsCategories = (item, records, chartConfig) => {
    records.forEach((record) => {
        updateGroupCategories(item, record, chartConfig);
    });
    updateCategorySummedValues(item, records, chartConfig);
};
const updateRecords = (records) => {
    let max = 0;
    const categoriesAndSummedValues = new Map();
    records.forEach((record) => {
        if (record.data.length > max) {
            max = record.data.length;
            record.data.forEach((value) => {
                categoriesAndSummedValues.set(value.name, value.custom?.categorySummedValue);
            });
        }
    });
    records.forEach((record) => {
        if (record.data.length < max) {
            categoriesAndSummedValues.forEach((summedValue, category) => {
                if (!record.data.some((value) => value.name === category)) {
                    record.data.push(createElement(category, 0, summedValue));
                }
            });
        }
    });
};
const getMetaData = (records) => {
    let masterDetailsChoice = "", max = 0, min = 0, sum = 0;
    let categories = [];
    records.forEach((record) => {
        categories = record.data?.map((point) => point.name) ?? categories;
        record.data.forEach((value) => {
            const categorySummedValue = value.custom?.categorySummedValue;
            const val = value.y ?? 0;
            if (val < min) {
                min = val;
            }
            if (categorySummedValue > max) {
                max = categorySummedValue;
                masterDetailsChoice = value.name;
            }
            if (val) {
                sum += val;
            }
        });
    });
    return { categories, masterDetailsChoice, max, min, sum };
};
const addColorIndexMetaData = (measureItem, record, groupBy) => {
    if (measureItem.measures?.[groupBy] === record.name && record.metaData) {
        record.metaData.colorIndex = measureItem.additionalData?.colorIndex;
    }
};
const setMetaData = (args, max, min, sum, masterDetailsChoice, categories, chartConfig) => {
    args.context.staticData.customResult?.forEach((record) => {
        if (!record.metaData) {
            record.metaData = {};
        }
        record.metaData.max = record.metaData.max && record.metaData.max > max ? record.metaData.max : max;
        record.metaData.min = record.metaData.min && record.metaData.min < min ? record.metaData.min : min;
        record.metaData.sum = sum;
        record.metaData.masterDetailsChoice = masterDetailsChoice;
        record.metaData.categories = categories;
        addColorIndexMetaData(args.visitable, record, chartConfig.groupBy);
    });
};
const createHorizontalStackedBarChartRecord = (name) => ({
    data: [],
    metaData: {
        max: 0,
        min: 0,
        sum: 0
    },
    name
});
// eslint-disable-next-line max-len,max-statements
export const horizontalStackedBarChart = (params) => (args) => {
    if (args.context.visitNodePassage !== VisitNodePassage.Always) {
        return;
    }
    const [{ value, groupBy, filterBy }] = params;
    if (value === "" || groupBy === "") {
        return;
    }
    const measureItem = args.visitable;
    if (!args.context.staticData?.customResult?.length) {
        args.context.staticData.customResult = [];
    }
    if (args.context.componentProps?.parentId && filterBy && filterBy !== "" &&
        args.context.widgetState?.masterDetailsChoice !== measureItem.measures?.[filterBy]) {
        return;
    }
    if (!args.context.staticData.customResult.some((elem) => elem.name === measureItem.measures?.[groupBy])) {
        args.context.staticData.customResult.push(createHorizontalStackedBarChartRecord(measureItem.measures?.[groupBy]));
    }
    updateGroupsCategories(measureItem, args.context.staticData.customResult, params[0]);
    updateRecords(args.context.staticData.customResult);
    const { max, min, sum, masterDetailsChoice, categories } = getMetaData(args.context.staticData.customResult);
    setMetaData(args, max, min, sum, masterDetailsChoice, categories, params[0]);
};
